export * from './fullHeight';
export * from './fullWidth';

export enum View {
    MOBILE_426 = "MOBILE_426",
    TABLET_768 = "TABLET_768",
    DESKTOP_1440 = "DESKTOP_1440",
};
